module.exports = __webpack_public_path__ + "img/SANTANDER_Credit_Free.98955740.jpg";